import type { FormEvent } from 'react';
import { Input, InputBar } from '@room/shared-ui';
import { Button } from '@room/shared-ui/components/ui/button';

export type MessageComposerProps = {
  messageDraft: string;
  onMessageChange: (value: string) => void;
  onSendMessage: (event: FormEvent<HTMLFormElement>) => void;
};

export function MessageComposer({
  messageDraft,
  onMessageChange,
  onSendMessage,
}: MessageComposerProps) {
  return (
    <form onSubmit={onSendMessage}>
      <InputBar
        border="top"
        safeAreaBottom
        input={(
          <Input
            value={messageDraft}
            onChange={(e) => onMessageChange(e.target.value)}
            placeholder="Type your message..."
            fullWidth
            className="message-input"
          />
        )}
        action={(
          <Button
            type="submit"
            variant="primary"
            disabled={!messageDraft.trim()}
            icon={<span>➤</span>}
            className="send-btn"
          />
        )}
      />
    </form>
  );
}
